const dealerTools = {
  methods: {},
  register: function register(key, method) {
    this.methods[key] = method;
  },
  get: function get(key = 'default') {
    return this.methods[key];
  }
};

export default dealerTools;
